import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Header />{{yield}}<Footer />")